import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import CareerDegreeSearch from './CareerDegreeSearch';
import { getTenantDegrees } from '../../store/actions';
import { getCategoryImages } from '../utility/getCategoryImages';
import { getOnboardingState, getAuthState } from '../../store/selectors';
import WindowTitle from '../utility/WindowTitle';

class DegreeSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      degreeList: '',
    };
  }

  async componentDidMount() {
    const response = await this.props.getTenantDegrees(this.props.tenant.id);
    const degreeList = getCategoryImages(
      response.filter((degree) => !degree.inactive && degree.hasMatches)
    );

    this.setState({
      degreeList,
    });
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <>
            <WindowTitle>{t('Search Degree')}</WindowTitle>
            <CareerDegreeSearch
              tenant={this.props.tenant}
              careerList={this.state.degreeList}
              inputText={t('Enter Degree')}
              careerOrDegree="degree"
            />
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const auth = getAuthState(state);

  return { onboarding, auth };
};

export default withRouter(
  connect(mapStateToProps, { getTenantDegrees })(DegreeSearch)
);
